<template>
  <div id="navBarContainer" class="navigation-container">
    <div id="header" class="mobile-header">
      <div class="logo-container">
        <a href="/" class="logo">
          <svg
            class="navigation-logo"
            viewBox="0 0 812 466"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M404.45 391.93C398.7 391.21 396.91 389.06 396.91 382.95C396.73 378.1 396.73 372.17 396.73 365.17C396.73 358.17 396.73 352.6 396.91 347.21C396.91 332.13 389.91 321.35 379.31 316.14C374.09 313.53 368.48 312.25 362.67 312.19C363.93 311.19 364.98 309.97 365.79 308.55C368.66 302.98 367.23 296.7 361.48 293.82C354.3 289.87 353.22 287.35 352.86 274.43V273.17C352.68 269.22 352.68 266.52 352.68 265.09C352.68 261.14 352.86 254.85 353.04 246.23V240.3C353.22 226.65 347.11 216.42 337.24 211.21C335 210.07 332.61 209.2 330.12 208.57C331.31 208.1 332.54 207.55 333.84 206.92C339.59 204.05 343.9 204.05 347.85 206.74C352.16 209.79 356.65 211.05 361.86 211.05C376.05 211.05 387.54 199.56 387.54 189.68C387.54 184.29 383.23 179.8 377.84 179.44C372.09 178.72 370.3 176.57 370.3 170.46C370.12 165.61 370.12 159.69 370.12 152.68C370.12 145.67 370.12 140.11 370.3 134.72C370.3 119.63 363.3 108.86 352.7 103.65C340.85 97.72 327.02 98.62 313.37 105.27C307.27 108.28 301.87 112.21 297.57 116.59C297.71 115.88 297.79 115.16 297.79 114.43C297.79 108.32 292.94 102.76 285.04 102.4C273.01 102.22 263.31 102.22 258.46 102.4C250.56 102.76 245.89 108.86 245.89 114.97C245.89 118.02 247.33 121.08 249.66 123.05C255.95 127.9 256.84 129.69 253.79 137.6L247.5 152.5C245.17 158.25 240.5 158.25 237.62 152.5C235.29 147.65 233.49 143.7 232.05 140.29C231.87 139.75 231.33 138.67 230.61 137.06C227.38 129.88 228.1 126.82 233.84 123.41C236.71 121.26 238.15 118.2 238.15 114.61C238.15 108.5 233.66 102.76 225.76 102.4C215.16 102.22 201.16 102.22 190.56 102.4C185.35 102.58 181.4 105.09 179.43 108.69C178.89 109.59 178.5 110.52 178.22 111.45C177.67 105.04 174.07 100.72 168.78 99.89C176.32 96.66 181.53 88.94 181.53 80.68C181.53 69.91 171.83 60.75 160.7 60.75C149.57 60.75 140.05 70.27 140.05 81.4C140.05 91.82 148.67 100.44 158.73 101.51C150.83 104.92 145.62 107.44 139.87 110.49C137.56 111.88 135.83 113.55 134.68 115.42C134.71 115.1 134.73 114.77 134.73 114.44C134.73 108.33 129.88 102.77 121.98 102.41C109.95 102.23 100.25 102.23 95.4 102.41C87.5 102.77 82.83 108.87 82.83 114.98C82.83 118.03 84.27 121.09 86.6 123.06C92.88 127.91 93.78 129.7 90.73 137.61L84.44 152.51C82.11 158.26 77.44 158.26 74.56 152.51C72.23 147.66 70.43 143.71 68.99 140.3C68.81 139.76 68.27 138.68 67.55 137.07C64.32 129.89 65.04 126.83 70.78 123.42C73.65 121.27 75.09 118.21 75.09 114.62C75.09 108.51 70.6 102.77 62.7 102.41C52.1 102.23 38.1 102.23 27.5 102.41C22.29 102.59 18.34 105.1 16.37 108.7C13.14 114.09 14.75 120.37 20.14 123.96C24.99 126.83 27.14 128.63 29.3 131.5C30.38 132.94 31.45 134.91 32.71 137.25C37.74 147.85 42.95 158.98 48.33 170.65C53.72 182.32 58.39 192.38 62.16 201.18C65.03 207.64 70.24 211.06 75.45 211.06C76.09 211.06 76.73 211.01 77.36 210.9C66.13 215.74 57.26 224.18 51.66 234.92C47.17 243.72 44.84 253.24 44.84 263.47C44.84 273.17 46.99 282.15 51.3 290.41C59.74 307.11 75.9 317.89 96.55 317.89C103.5 317.89 109.98 316.62 115.75 314.43C110.23 317.74 105.9 322.13 102.88 327.32C95.88 339.35 96.06 355.51 102.88 367.19C106.65 373.48 106.47 376.53 103.06 381.38C100.68 384.6 99.18 388.38 98.64 392.53C96.92 390.87 94.63 389.77 92.09 389.6C86.34 388.88 84.55 386.73 84.55 380.62C84.37 375.77 84.37 369.85 84.37 362.84C84.37 355.83 84.37 350.27 84.55 344.88C84.55 329.8 77.55 319.02 66.95 313.81C55.1 307.88 41.27 308.78 27.62 315.43C12.36 322.97 1.39996 336.26 1.39996 347.93C1.39996 361.04 15.05 366.43 25.64 361.04C30.85 358.35 34.44 353.14 34.98 345.42V343.63C35.16 342.19 35.16 341.29 35.16 340.94C35.7 337.17 38.93 335.01 43.24 335.01C49.71 335.01 52.58 338.96 52.58 345.42V348.11C52.58 353.14 50.96 355.83 44.86 358.35L42.52 359.25C37.85 361.05 33.18 362.84 28.51 364.64C15.04 369.85 7.13996 375.06 3.00996 382.24C1.02996 385.83 -0.0400391 390.14 -0.0400391 394.99C-0.0400391 410.43 10.91 421.21 29.59 421.21C37.31 421.21 41.8 420.13 48.09 417.08C53.84 414.21 58.15 414.21 62.1 416.9C66.41 419.95 70.9 421.21 76.11 421.21C87.26 421.21 96.74 414.11 100.29 406.28C102.11 411.89 101.49 413.68 98.58 416.93C94.09 421.78 91.76 427.88 91.76 434.89C91.76 455 111.69 465.6 137.55 465.6C149.4 465.6 160.18 463.62 169.69 459.49C188.9 451.59 200.58 436.86 200.58 420.16C200.58 415.31 199.5 410.82 197.53 406.51C193.22 397.89 183.52 391.43 167.72 390.71H165.92C164.66 390.53 163.77 390.17 163.05 389.45C161.25 387.83 161.61 384.78 164.85 383.52C166.47 382.62 167.9 381.9 169.34 381.01C171.32 379.75 173.11 378.68 176.16 375.62C183.88 368.62 187.83 360.89 188.73 349.58C188.91 347.6 189.27 346.17 189.63 345.27C190.35 343.29 191.96 341.68 196.99 339.34C198.21 338.75 199.29 337.95 200.23 336.99C202.03 338.16 203.44 339.13 204.31 340C207 342.34 207.72 345.03 207.72 351.31C207.9 353.29 207.9 356.52 207.9 361.01C207.9 366.04 207.72 375.74 207.54 390.28C207.54 403.75 213.47 414.16 223.52 419.37C233.04 424.4 245.79 424.58 258.18 419.91C263.57 417.93 266.26 417.58 268.78 418.83C270.93 419.91 273.45 423.32 278.66 423.32C280.99 423.32 283.69 422.78 286.56 421.88C295.36 418.83 300.39 416.85 307.03 413.98C310.43 412.52 312.75 409.92 313.91 406.89C317.59 417.01 327.43 423.5 341.92 423.5C349.64 423.5 354.13 422.42 360.42 419.37C366.17 416.5 370.48 416.5 374.43 419.19C378.74 422.24 383.23 423.5 388.44 423.5C402.63 423.5 414.12 412.01 414.12 402.13C414.12 396.74 409.81 392.25 404.42 391.89L404.45 391.93ZM52.62 384.58C52.62 388.89 47.05 394.46 40.23 394.46C36.64 394.46 34.84 393.02 34.84 390.15C34.84 386.38 38.25 383.51 45.26 381.17C51.01 379.02 52.62 380.09 52.62 382.97V384.59V384.58ZM293.42 250.91C293.6 246.96 294.32 243.55 295.57 240.85C298.26 235.1 304.01 232.23 309.04 232.23C315.5 232.23 321.07 237.44 321.07 245.34C321.25 255.58 321.25 266.71 321.07 274.07C320.71 288.08 319.45 290.23 313.35 293.11C309.94 294.73 307.96 297.42 307.25 300.47C306.71 297.78 305.1 295.62 302.4 294.01C297.37 291.32 295.4 289.34 294.5 284.85C293.42 279.82 293.06 268.69 293.42 250.91ZM338.32 174.43C338.32 178.74 332.75 184.31 325.93 184.31C322.34 184.31 320.54 182.87 320.54 180C320.54 176.23 323.95 173.35 330.96 171.02C336.71 168.87 338.32 169.94 338.32 172.82V174.44V174.43ZM169 430.77C169 436.7 161.28 439.75 146.01 439.75C129.31 439.75 121.95 436.7 121.95 430.41C121.95 425.2 126.8 423.23 136.32 423.23H151.59C163.8 423.23 169.01 425.56 169.01 430.77H169ZM132.55 347.08C132.55 336.31 136.32 328.94 143.15 328.94C150.33 328.94 154.64 336.3 154.64 347.8C154.64 358.57 150.87 366.12 144.04 366.12C136.86 366.12 132.55 358.58 132.55 347.08ZM171.7 312.07C169.01 311.17 166.67 310.45 164.52 309.92C160.21 308.66 153.03 307.59 143.51 307.59C135.84 307.59 129.03 308.79 123.16 310.96C130.77 306.55 136.6 300.41 139.88 293.67C142.57 288.1 140.42 281.82 135.57 278.94C131.08 276.43 125.69 277.14 121.38 281.45C115.81 287.2 110.25 290.07 102.34 290.07C88.69 290.07 78.99 279.3 78.99 256.31C78.99 237.63 85.28 229.37 94.97 229.37C100.9 229.37 104.49 232.42 106.82 239.07C111.85 252.36 124.06 255.41 132.86 250.56C139.86 246.79 143.63 237.99 139.86 228.11C135.55 216.26 120.64 206.38 100.17 206.38C93.67 206.38 87.58 207.37 81.98 209.19C84.63 207.57 86.95 204.94 88.58 201.38C94.51 187.55 100.25 174.44 105.46 162.23L113 145.17L116.23 137.45C119.82 129.19 121.44 127.57 127.9 124.7C130.17 123.66 131.94 122.07 133.11 120.17C133.08 120.48 133.04 120.79 133.04 121.11C133.04 124.52 134.84 128.11 138.43 130.45C140.76 132.07 142.38 133.5 143.46 134.58C145.61 136.73 146.51 139.79 146.51 145.71V158.1C146.51 166.9 146.33 173.54 145.61 177.31C144.71 182.16 142.56 184.31 137.71 187.01C134.12 188.99 132.14 192.58 132.14 196.35C132.14 202.46 136.99 208.02 144.17 208.38C156 208.91 167.66 208.91 179.49 208.4C167.13 212.6 156.97 221.06 150.48 232.7C145.63 241.14 143.3 250.66 143.3 261.25C143.3 271.84 145.63 281 150.3 289.44C156.94 301.44 167.58 310.17 180.59 314.22C177.68 314.19 175.69 313.64 171.68 312.07H171.7ZM199.52 293.93C195.93 293.93 192.52 292.49 189.46 289.8C183 284.59 179.04 273.82 178.33 259.99V257.12C178.33 238.8 185.87 228.21 195.93 228.21C206.71 228.21 216.4 240.96 217.12 261.79C217.3 262.33 217.3 263.41 217.3 264.66C217.3 282.98 209.58 293.93 199.52 293.93ZM267.19 380.62C267.19 386.55 264.5 392.29 259.65 395.17C254.8 398.22 249.59 398.58 245.46 395.89C241.87 393.74 239.53 389.43 239.53 383.14V326.75C239.53 317.23 234.86 312.38 225.52 312.38H223.01C221.67 312.51 220.29 312.64 218.88 312.79C221.16 311.87 223.39 310.8 225.55 309.56C242.07 300.04 252.13 282.08 252.13 261.07C252.13 250.47 249.8 240.96 245.13 232.52C235.79 215.64 218.73 205.4 198.08 205.4C194.12 205.4 190.27 205.78 186.58 206.51C188.51 205.36 190.04 203.76 191.06 201.91C193.75 196.7 192.86 189.88 186.57 186.65C181.72 184.31 179.93 182.52 179.21 177.67C178.13 172.46 178.13 159.89 178.13 143.73C178.13 136.91 178.13 128.27 178.25 117.56C179.01 120.04 180.69 122.3 183.2 123.97C188.05 126.84 190.2 128.64 192.36 131.51C193.44 132.95 194.51 134.92 195.77 137.26C200.8 147.86 206.01 158.99 211.39 170.66C216.78 182.33 221.45 192.39 225.22 201.19C228.09 207.65 233.3 211.07 238.51 211.07C243.72 211.07 248.75 207.66 251.62 201.37C257.55 187.54 263.29 174.43 268.5 162.22L276.04 145.16L279.27 137.44C282.86 129.18 284.48 127.56 290.94 124.69C291.07 124.63 291.2 124.56 291.32 124.5C288.64 128.91 287.12 133.46 287.12 137.8C287.12 150.91 300.77 156.3 311.36 150.91C316.57 148.22 320.16 143.01 320.7 135.29V133.49C320.88 132.05 320.88 131.16 320.88 130.8C321.42 127.03 324.65 124.87 328.96 124.87C335.42 124.87 338.3 128.82 338.3 135.28V137.97C338.3 143 336.68 145.69 330.58 148.21L328.25 149.11C323.58 150.91 318.91 152.7 314.24 154.5C300.77 159.71 292.87 164.92 288.74 172.1C286.76 175.69 285.69 180 285.69 184.85C285.69 197.35 292.87 206.79 305.51 209.94C304.46 210.28 303.42 210.64 302.37 211.05C299.5 212.13 297.16 212.67 295.19 212.67C292.14 212.67 289.62 211.77 286.57 209.08C283.34 206.39 279.21 205.85 273.64 208.36C269.15 210.34 263.58 213.03 256.94 216.44L255.86 216.98C247.06 221.29 245.62 232.06 253.53 237.27C255.86 238.89 257.48 240.32 258.56 241.4C260.54 243.55 261.43 246.25 261.43 252.71C261.43 255.23 261.61 262.05 261.61 268.51V274.97C261.25 286.82 259.81 290.24 252.99 293.83C249.22 295.98 247.24 299.58 247.24 303.35C247.24 309.1 252.09 314.48 259.63 315.2C260.09 315.22 260.57 315.24 261.05 315.26C257.91 316.44 255.51 318.67 254.24 321.35C251.55 326.56 253.34 333.56 258.55 336.43C263.58 339.3 265.55 341.28 266.45 344.69C267.35 348.1 267.35 354.03 267.35 365.52C267.35 372.52 267.35 377.55 267.17 380.6L267.19 380.62ZM364.94 386.9C364.94 391.21 359.37 396.78 352.55 396.78C348.96 396.78 347.16 395.34 347.16 392.47C347.16 388.7 350.57 385.83 357.58 383.49C363.33 381.34 364.94 382.41 364.94 385.29V386.91V386.9ZM364.94 350.45C364.94 355.48 363.32 358.17 357.22 360.69L354.89 361.59L340.88 366.98C327.41 372.19 319.51 377.4 315.38 384.58C313.68 387.66 312.65 391.28 312.4 395.31C311.25 393.87 309.7 392.73 307.79 392.12C305.1 391.22 303.3 390.14 302.22 389.25C299.89 387.27 299.17 384.04 299.17 375.96V325.86C299.17 321.05 297.71 317.49 294.88 315.23C295 315.23 295.11 315.22 295.23 315.21C301.69 314.85 306.18 310.54 307.26 305.51C308.34 310.54 313.01 314.85 319.47 315.21C324.86 315.39 330.6 315.57 336.71 315.57C339.78 315.57 342.63 315.53 345.32 315.48C343.54 316.15 341.77 316.91 339.99 317.77C324.73 325.31 313.77 338.6 313.77 350.27C313.77 363.38 327.42 368.77 338.01 363.38C343.22 360.69 346.81 355.48 347.35 347.76V345.96C347.53 344.52 347.53 343.63 347.53 343.27C348.07 339.5 351.3 337.34 355.61 337.34C362.07 337.34 364.95 341.29 364.95 347.76V350.45H364.94Z"
              fill="white"
            />
            <path
              d="M718.22 77.28C667.27 32.26 605.39 4.39 562.12 0.0600022C557.76 -0.379998 553.53 1.74 551.28 5.5C549.02 9.26 549.14 13.98 551.57 17.63C555.42 23.39 556.44 33.83 552.81 47.52C549.31 60.73 542.09 74.44 533.42 84.51L533.4 84.54C522.85 96.88 510.78 109.19 498.12 122.46C485.59 135.59 472.64 149.49 461.01 164.45C437.7 194.41 418.99 229.42 418.99 272.85C418.99 316.28 441.35 363.14 476.33 398.75C511.44 434.49 560.42 460.23 615.12 460.23C723.51 460.23 811.25 372.52 811.25 264.16C811.25 186.52 769.37 122.48 718.22 77.29V77.28ZM767.59 195.08C768.84 192.42 770.81 188.39 771.4 184.5C773.83 190 776.04 195.61 778 201.33C773.71 197.75 766.46 202.95 767.59 195.08ZM441.65 272.84C441.65 258.96 443.91 245.98 447.91 233.69C447.36 238.75 448.11 243.04 450.58 246.21C465.78 268.1 471.71 258.73 486.21 270.54C489.73 274.82 504.82 281.67 505.3 288.78C504.9 311.1 493.05 322.13 513.55 340.72C533.53 358.83 530.58 375.22 533.09 397.11C534.88 404.26 535.67 411.15 537.64 417.14C520.94 408.03 505.71 396.32 492.5 382.87C460.61 350.41 441.65 309.11 441.65 272.84ZM615.12 437.57C596.64 437.57 578.77 434.16 561.96 428.1C561.98 427.96 562.01 427.83 562.01 427.7C561.18 422.45 556.75 422.88 557.98 414.83C559.29 406.28 564.13 405.74 566.49 399.39C567.57 394.29 568.42 390.95 572 386.56C578.04 379.36 584.48 370.11 589.96 362.81C596.68 355.62 590.57 340.87 592.85 332.29C597.08 319.46 605.29 306.31 591.15 297.24C582.75 292.02 578.56 296.03 575.49 288.78C571.58 279.58 568.74 273.99 559.84 266.93C550.45 259.48 545.8 249.45 533.32 249.74C522.65 249.98 523.03 260.96 516.74 262.39C510.45 263.81 508.54 273.6 503.08 274.84C497.62 276.08 497.04 268.81 495.31 265.73C493.58 262.65 493.51 258.86 493.77 255.08C494.21 248.73 497.43 242 491.58 242C484.37 242.61 490.05 252.28 486.22 253.87C482.38 255.45 483.17 251.69 481.95 250.35C480.27 248.24 476.8 250.77 475.98 248.28C473.86 242.73 474.08 238.53 476.03 233.06C479.47 223.42 485.93 224.16 494.54 223.95C499.52 223.83 501.23 220.46 503.64 220.16C508.49 219.57 501.57 228.32 504.44 232.25C508.82 238.25 514.56 227.42 514.33 223.02C513.8 213.01 510.88 199.55 525.06 196.01C532.36 194.19 556.43 180.55 553.44 172.93C553.41 172.84 553.31 172.63 553.27 172.58C550.73 169.15 554.49 166.06 557.82 164.48C560.88 163.02 576.22 153 577.6 150.27C579.97 145.48 575.76 140.9 571.08 137.78C567.01 135.14 561.73 137.94 556.83 138.24C550.4 138.73 549.94 130.89 542.93 132.66C540.06 133.34 539.27 136.11 537.77 138.11C535.4 141.28 530.87 144.06 528.1 142.57C521.23 138.73 531.94 131.17 520.54 131.8C527.34 124.7 534.14 117.6 540.64 110.5C539.94 113 539.13 115.52 539.31 116.58C539.69 125.25 551.47 126.52 555.65 126.7C555.87 126.7 555.97 126.71 555.99 126.71C556.91 126.75 557.67 126.9 558.53 127.2C560.13 127.77 562.72 128.81 564.32 130.03C568.16 132.96 573.48 132.07 576.68 128.09C578.98 125.19 579.85 121.82 579.97 118.12C580.02 115.72 579.97 113.24 580.21 110.82C580.58 106.9 581.99 103.38 584.27 100.28C586.7 96.87 589.12 93.35 591.45 89.85C593.37 86.88 594.53 83.59 594.94 80.06C595.7 73.41 592.55 68.12 586.96 67.05C580.14 65.78 573.3 67.65 568.54 70.59C571.07 64.93 573.15 59.12 574.69 53.34C577.05 44.45 578.31 34.8 577.38 25.61C606.86 32.46 643.91 49.27 678.84 74.74C673.66 77.09 668.7 81.64 664.13 88.9C659.51 101.95 672.07 100.19 678.63 107.63C685.13 115.22 692.67 107.49 689.56 99.08C689.31 97.89 691.22 92.36 692.56 92.34C695.05 92.75 695.12 98.13 698.43 99.55C700.04 100.71 701.7 101.61 703.03 103.04C704.74 104.91 704.12 109.42 701.35 109.76C696.47 110.92 691.99 112.11 688.71 116.49C681.98 125.03 678.84 119.12 675.22 112.2C667.36 103.33 664.14 118.13 663.82 124.33C662.99 132.67 649.72 132.43 652.68 142.25C657.71 153.6 641.26 155.39 640.26 165.25C639.37 170.93 643.1 176 647.93 176.55C650.33 176.76 661.02 178.11 662.84 176.28C666.97 172.41 659.86 163.44 662.84 162.52C666.81 161.33 668.32 163.36 670.38 160.96C672.96 157.83 672.61 155.23 676.17 155.55C681.29 155.77 682.14 163.61 684.82 167.45C686.36 171.91 679.96 171.09 680.33 173.05C680.7 175.01 683.4 177.34 685.66 176.22C687.04 175.53 686.69 172.15 688.51 171.29C689.65 170.75 690.36 170.78 691.19 168.12C691.93 165.75 690.08 166.16 689.51 164.64C688.67 162.23 687.12 154.76 684.98 152.66C684.06 151.36 681.91 150.51 682.37 148.64C683.21 146.15 686.59 147.09 687.81 149.1C689.8 152.26 691.82 156.17 695.28 157.77C701.42 160.34 686.08 176.93 708.44 177.34C714.21 176.37 712.76 168.49 712.15 164.12C711.64 157.38 720.97 156.85 723.86 150.49C725.59 147.87 727.14 144.7 729.87 142.93C734.51 139.83 739.87 146.23 738.11 151.23C735.94 162.07 721.64 156.16 717.35 164.48C712.58 179.05 739.58 170.43 736.29 183.94C735.95 191.62 709.66 189.42 712.19 201.25C714.14 207.35 719.89 208.95 724.86 216.76C730.62 225.79 728 249.35 743.51 249.35C751.63 249.35 746.79 232.38 773.61 233.88C780.59 232.91 783.8 229.59 784.2 223.85C787 236.84 788.54 250.29 788.54 264.19C788.54 360.04 710.95 437.61 615.07 437.61L615.12 437.57Z"
              fill="white"
            />
            <path
              d="M731.16 254.18C722.25 231.71 720.07 237.57 716.65 227.55C696.47 165.79 688.61 212.42 661.81 192.31C623.94 151.3 597.45 197.48 602.44 237.12C607.64 280.73 644.8 269.67 651.64 293.32C656.4 309.91 647.05 327.07 651.86 343.9C653.19 350.28 654.73 356.66 656.39 363.04C660.46 378.61 649.11 393.12 652.08 408.92C652.36 419.43 664.4 432.78 671.43 419.7C675.64 411.03 682.29 406.24 689.01 400.26C703.77 386.18 700.32 362.12 705.7 343.75C711.26 312.99 737.24 317.53 744.29 292.56C746.94 281.47 750.37 266.14 744.29 258.09C741.75 254.6 733.23 259.39 731.16 254.18Z"
              fill="white"
            />
            <path
              d="M644.63 113.18C644.63 113.18 644.66 113.31 644.71 113.55C644.95 114.68 645.26 116.15 645.81 117.51C647.59 122.19 648.45 125.44 652.41 127L654.23 127.65C655.22 128.04 656.11 127.65 656.81 127C657.9 125.96 658.69 124.4 658.59 122.58C658.49 121.28 658.19 119.98 657.7 118.81C656.11 115.04 654.53 111.27 652.84 107.5C652.44 106.72 651.95 105.81 651.35 105.16C649.67 103.34 647.49 103.47 646 105.55C644.98 107 644.55 108.63 644.44 111.03C644.44 111.07 644.44 110.97 644.44 110.99C644.41 111.81 644.46 112.39 644.62 113.19L644.63 113.18Z"
              fill="white"
            />
            <path
              d="M641.6 122.99C643.16 122.99 644.15 121.31 644.07 118.69C644.07 116.3 642.34 114.03 640.6 114.15C639.03 114.15 637.79 116.06 637.88 118.1C637.88 120.7 639.73 123.06 641.61 123L641.6 122.99Z"
              fill="white"
            />
            <path
              d="M608.07 103.27C611.91 102.6 610.12 98.89 611.01 96.43C613.59 93.25 618.57 95.68 617.09 88.05C614.77 81.54 606.95 77.43 601.07 86.01C599.75 87.99 598.35 93.12 599.54 96.8C599.87 98.1 603.2 104.11 608.08 103.27H608.07Z"
              fill="white"
            />
            <path
              d="M725.97 339.64C721.6 340.79 721.64 347.43 719.77 348.16C707.03 353.04 706.4 379.44 710.14 381.73C717.56 386.25 721.56 364.42 724.55 359.2C726.46 354.95 736.09 335.67 725.97 339.64Z"
              fill="white"
            />
            <path
              d="M508.4 245.17C508.4 245.17 508.4 245.19 508.4 245.2C508.4 245.21 508.41 245.1 508.4 245.15C508.4 245.15 508.4 245.17 508.4 245.18V245.17Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
      <div class="language-container-mobile">
        <div class="language-fit">
          <LanguageSelection />
        </div>
      </div>
      <div class="burger-menu-icon" @click="toggleMenu()">
        <div id="burger-top-bar" class="burger-bar burger-bar-appear"></div>
        <div
          id="burger-middle-bar-1"
          class="burger-bar burger-bar-display"
        ></div>
        <div id="burger-middle-bar-2" class="burger-bar burger-bar-hide"></div>
        <div id="burger-bottom-bar" class="burger-bar burger-bar-appear"></div>
      </div>
    </div>
    <div id="navContainer" class="navContainer">
      <div class="custom-nav-bar">
        <ul id="menuList" class="menu-inactive">
          <li
            v-for="route in navigationList"
            @click="navigate(route)"
            :key="route.name"
          >
            <router-link
              :title="$t(route.meta.title)"
              :to="route.path"
              :class="{ 'is-active': isActive(route) }"
              >{{ $t(route.meta.title) }}</router-link
            >
            <div
              class="secondSubMenu"
              v-if="route.children && current_route.name == route.name"
            >
              <router-link
                @click="toggleMenu()"
                v-for="subTab in subNavigation(route)"
                :key="subTab.name"
                :title="$t(subTab.meta.title)"
                :to="subTab.path"
                >{{ $t(subTab.meta.title) }}</router-link
              >
            </div>
          </li>
          <li class="close-tabs" @click="toggleMenu()"><a>X</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LanguageSelection from "@/components/utils/LanguageSelection";

export default {
  name: "Navigation",
  components: {
    LanguageSelection,
  },
  data() {
    return {
      current_route: {},
    };
  },
  methods: {
    subNavigation(route) {
      return route.children.filter((route) => {
        // Check for correct meta
        if (route.meta == undefined) {
          route.meta = { title: "Missing identifier" };
          return true;
        }

        // Check visibility
        if (route.meta.visible != undefined && !route.meta.visible) {
          return false;
        }

        // Check permissions
        if (route.meta.permissions != undefined) {
          if (!this.session) {
            return false;
          }

          if (this.hasSystemPermission()) {
            return true;
          }

          if (this.hasPoolPermission()) {
            var roles = this.pool_roles.find((el) =>
              route.meta.permissions.includes(el.name)
            );
            return roles != undefined;
          }
          return false;
        }

        // Check session
        if (route.meta.session != undefined) {
          if (
            (this.session && route.meta.session == false) ||
            (!this.session && route.meta.session == true)
          ) {
            return false;
          }
        }

        return true;
      });
    },
    isActive(route) {
      return route == this.current_route;
    },
    navigate(route) {
      if (this.current_route !== route) {
        this.current_route = route;
      } else {
        this.toggleMenu();
      }
    },
    toggleMenu() {
      const menuList = document.getElementById("menuList");
      const topBar = document.getElementById("burger-top-bar");
      const middleBar1 = document.getElementById("burger-middle-bar-1");
      const middleBar2 = document.getElementById("burger-middle-bar-2");
      const bottomBar = document.getElementById("burger-bottom-bar");
      if (menuList.classList.contains("menu-inactive")) {
        window.scrollTo(0, 0);
        menuList.classList.remove("menu-inactive");
        menuList.classList.add("menu-active");
        topBar.classList.remove("burger-bar-appear");
        topBar.classList.add("burger-bar-disappear");
        bottomBar.classList.remove("burger-bar-appear");
        bottomBar.classList.add("burger-bar-disappear");
        middleBar2.classList.remove("burger-bar-hide");
        middleBar2.classList.add("burger-bar-display");
        middleBar1.classList.add("burger-bar-rotate-1");
        middleBar2.classList.add("burger-bar-rotate-2");
      } else {
        menuList.classList.remove("menu-active");
        menuList.classList.add("menu-inactive");
        topBar.classList.add("burger-bar-appear");
        topBar.classList.remove("burger-bar-disappear");
        bottomBar.classList.add("burger-bar-appear");
        bottomBar.classList.remove("burger-bar-disappear");
        middleBar2.classList.add("burger-bar-hide");
        middleBar2.classList.remove("burger-bar-display");
        middleBar1.classList.remove("burger-bar-rotate-1");
        middleBar2.classList.remove("burger-bar-rotate-2");
      }
    },
  },
  computed: {
    ...mapGetters({
      session: "session",
      current: "navigation/current",
      tabs: "navigation/tabs",
      hasCrew: "user/crew/hasCrew",
      pool_roles: "user/roles/pool",
      hasPoolPermission: "user/roles/hasPoolPermission",
      hasSystemPermission: "user/roles/hasSystemPermission",
    }),
    navigationList() {
      return this.$router.options.routes.filter((route) => {
        // Check for correct meta
        if (route.meta == undefined) {
          route.meta = { title: "Missing identifier" };
          return true;
        }

        // Check visibility
        if (route.meta.visible != undefined && !route.meta.visible) {
          return false;
        }

        // Check crew
        if (route.meta.crew != undefined && route.meta.crew) {
          if (!this.session) {
            return false;
          }
          if (!this.hasCrew) {
            return false;
          }
        }

        // Check permissions
        if (route.meta.permissions != undefined) {
          if (!this.session) {
            return false;
          }

          if (this.hasSystemPermission()) {
            return true;
          }

          if (this.hasPoolPermission()) {
            var roles = this.pool_roles.find((el) =>
              route.meta.permissions.includes(el.name)
            );
            return roles != undefined;
          }
          return false;
        }

        // Check session
        if (route.meta.session != undefined) {
          if (
            (this.session && route.meta.session == false) ||
            (!this.session && route.meta.session == true)
          ) {
            return false;
          }
        }

        return true;
      });
    },
  },
};
</script>
<style lang="scss">
.mobile-header {
  position: sticky;
  top: 0;
  display: flex;
  height: 50px;
  width: 100%;
  z-index: 100;
  background-color: $blue;

  .logo-container {
    order: 0;
    flex-grow: 1;
    padding-left: 10px;
    display: flex;

    .logo {
      cursor: pointer;

      svg {
        margin-top: 8px;
        max-height: 38px;
        width: 60px;
        margin-left: 5px;
      }
    }
  }

  .language-container-mobile {
    display: flex;
    width: max-content;
    margin: auto;
    padding-right: 10px;
    order: 1;
    flex-grow: 0;

    span.normal-flag {
      transform: scale(0.35);
      -ms-transform: scale(0.35);
      -webkit-transform: scale(0.35);
      -moz-transform: scale(0.35);
      margin: -15px -20px;
    }

    span.small-flag {
      transform: scale(0.2);
      -ms-transform: scale(0.2);
      -webkit-transform: scale(0.2);
      -moz-transform: scale(0.2);
      margin: -15px -25px;
    }
  }

  .burger-menu-icon {
    position: relative;
    margin: auto;
    display: block;
    order: 2;
    flex-grow: 0;
    padding: 0 15px 0 15px;
    cursor: pointer;

    .burger-bar {
      width: 20px;
      height: 3px;
      background-color: $vca-primary-dark;
      margin: 4px 0 4px 0;
      border-radius: 2px;
      transition: all 0.2s;
    }

    .burger-bar-display {
      display: block;
    }
    .burger-bar-hide {
      display: none;
    }
    .burger-bar-appear {
      opacity: 1;
    }
    .burger-bar-disappear {
      opacity: 0;
    }
    .burger-bar-rotate-1 {
      position: absolute;
      bottom: 3px;
      transform: rotate(45deg);
    }
    .burger-bar-rotate-2 {
      position: absolute;
      bottom: 3px;
      transform: rotate(-45deg);
    }
  }
}

.navContainer {
  position: relative;

  .custom-nav-bar {
    ul {
      position: absolute;
      z-index: 99;
      border-top: solid thin $vca-primary-dark;
      border-bottom: solid thin $white;
      padding: 0;
      margin-top: 0;
      -moz-box-pack: center;
      justify-content: center;
      list-style-type: none;
      display: block;
      transition: all 0.4s;
      width: 50%;
      top: 0;
      right: 0;
      background-color: $blue;

      &.menu-inactive {
        visibility: hidden;
        opacity: 0;
        transform: translateY(10px);
      }
      &.menu-active {
        visibility: visible;
        box-sizing: border-box;
        position: absolute;
        width: 100%;
        opacity: 1;
      }

      li {
        flex: auto;

        a {
          color: $white;
          cursor: pointer;
          display: block;
          padding: 10px 10px;
          text-align: center;
          text-decoration: none;

          &:hover:not(.router-link-active) {
            color: $vca-primary-dark;
          }
          &:hover {
            color: $blue;
          }
          &.router-link-active {
            background-color: $vca-primary-dark;
            &.is-active {
              border-bottom: solid thin $white;
            }
          }
        }

        &.close-tabs {
          background-color: $vca-primary-dark;

          a {
            padding: 0;
          }
        }
      }
    }
  }
}

.secondSubMenu {
  position: relative;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: auto;
  background: $vca-primary-dark;
  box-sizing: border-box;

  a {
    &:hover {
      color: $blue !important;
    }
    &.router-link-exact-active {
      border-bottom: none !important;
      font-weight: bolder;

      &:before {
        content: "> ";
      }
      &:after {
        content: " <";
      }
    }
  }
}
</style>
